
export default function QualityControlSection() {
  return (
    <section className="py-20 bg-[#f5f5f5]">
      <div className="mx-auto px-6 lg:px-[15%]">
        <div className="text-center mb-16">
          <h2 className="text-lg sm:text-xl lg:text-2xl xl:text-4xl font-bold text-[#663333] mb-4">
            标准化品控流程
          </h2>
          <p className="text-xs sm:text-sm lg:text-lg text-gray-600 max-w-2xl mx-auto">
            从入库到出厂，每一个环节都有严格的品质管控标准
          </p>
          <div className="w-24 h-1 bg-[#cc9966] mx-auto mt-6"></div>
        </div>

        {/* 品控流程步骤 */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-16">
          <div className="text-center group">
            <div className="relative mb-8">
              <div className="w-20 h-20 sm:w-24 sm:h-24 md:w-28 md:h-28 flex items-center justify-center bg-[#cc9966] rounded-full mx-auto mb-6 shadow-xl group-hover:scale-110 transition-transform duration-300">
                <span className="text-xl sm:text-2xl md:text-3xl font-bold text-white">1</span>
              </div>
              <div className="absolute -top-2 -right-2 w-6 h-6 sm:w-7 sm:h-7 md:w-8 md:h-8 bg-[#663333] rounded-full flex items-center justify-center">
                <i className="ri-shield-check-fill text-white text-xs"></i>
              </div>
            </div>
            <h3 className="text-sm sm:text-base lg:text-xl xl:text-2xl font-bold text-[#663333] mb-4">入库审评</h3>
            <p className="text-xs sm:text-sm text-gray-600 leading-relaxed">
              专业审评师团队对每批茶叶进行全面感官品质评定，从外观、香气、滋味、叶底四个维度严格把关，确保符合入库标准
            </p>
          </div>
          
          <div className="text-center group">
            <div className="relative mb-8">
              <div className="w-20 h-20 sm:w-24 sm:h-24 md:w-28 md:h-28 flex items-center justify-center bg-[#cc9966] rounded-full mx-auto mb-6 shadow-xl group-hover:scale-110 transition-transform duration-300">
                <span className="text-xl sm:text-2xl md:text-3xl font-bold text-white">2</span>
              </div>
              <div className="absolute -top-2 -right-2 w-6 h-6 sm:w-7 sm:h-7 md:w-8 md:h-8 bg-[#663333] rounded-full flex items-center justify-center">
                <i className="ri-health-book-fill text-white text-xs"></i>
              </div>
            </div>
            <h3 className="text-sm sm:text-base lg:text-xl xl:text-2xl font-bold text-[#663333] mb-4">年度体检</h3>
            <p className="text-xs sm:text-sm text-gray-600 leading-relaxed">
              定期检测茶叶转化情况和品质变化，科学调整仓储环境参数，确保每一款茶叶都能达到最佳陈化效果
            </p>
          </div>
          
          <div className="text-center group">
            <div className="relative mb-8">
              <div className="w-20 h-20 sm:w-24 sm:h-24 md:w-28 md:h-28 flex items-center justify-center bg-[#cc9966] rounded-full mx-auto mb-6 shadow-xl group-hover:scale-110 transition-transform duration-300">
                <span className="text-xl sm:text-2xl md:text-3xl font-bold text-white">3</span>
              </div>
              <div className="absolute -top-2 -right-2 w-6 h-6 sm:w-7 sm:h-7 md:w-8 md:h-8 bg-[#663333] rounded-full flex items-center justify-center">
                <i className="ri-award-fill text-white text-xs"></i>
              </div>
            </div>
            <h3 className="text-sm sm:text-base lg:text-xl xl:text-2xl font-bold text-[#663333] mb-4">出厂检验</h3>
            <p className="text-xs sm:text-sm text-gray-600 leading-relaxed">
              出厂前进行最后一道品质把关，通过专业设备检测和人工审评双重保障，确保每一款产品都达到完美状态
            </p>
          </div>
        </div>

        {/* 品控数据展示 */}
        <div className="bg-white rounded-3xl p-12 shadow-xl">
          <h3 className="text-sm sm:text-base lg:text-xl xl:text-2xl font-bold text-[#663333] text-center mb-12">品控数据一览</h3>
          
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="text-2xl sm:text-3xl lg:text-4xl font-bold text-[#cc9966] mb-2">18</div>
              <p className="text-[#663333] font-semibold text-xs sm:text-sm">专业审评师</p>
              <p className="text-xs sm:text-sm text-gray-600 mt-1">平均15年经验</p>
            </div>
            
            <div className="text-center">
              <div className="text-2xl sm:text-3xl lg:text-4xl font-bold text-[#cc9966] mb-2">365</div>
              <p className="text-[#663333] font-semibold text-xs sm:text-sm">天品控监测</p>
              <p className="text-xs sm:text-sm text-gray-600 mt-1">全年无休监控</p>
            </div>
            
            <div className="text-center">
              <div className="text-2xl sm:text-3xl lg:text-4xl font-bold text-[#cc9966] mb-2">72</div>
              <p className="text-[#663333] font-semibold text-xs sm:text-sm">项检测指标</p>
              <p className="text-xs sm:text-sm text-gray-600 mt-1">全面品质评估</p>
            </div>
            
            <div className="text-center">
              <div className="text-2xl sm:text-3xl lg:text-4xl font-bold text-[#cc9966] mb-2">99.8%</div>
              <p className="text-[#663333] font-semibold text-xs sm:text-sm">品质合格率</p>
              <p className="text-xs sm:text-sm text-gray-600 mt-1">行业领先水平</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
